import { render, staticRenderFns } from "./setUpApplicationForm.vue?vue&type=template&id=49257b36&scoped=true"
import script from "./setUpApplicationForm.vue?vue&type=script&lang=js"
export * from "./setUpApplicationForm.vue?vue&type=script&lang=js"
import style0 from "./setUpApplicationForm.vue?vue&type=style&index=0&id=49257b36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49257b36",
  null
  
)

export default component.exports